var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsersPrimary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5118 7.57672C18.0743 7.57672 19.3419 6.31009 19.3419 4.74759C19.3419 3.18509 18.0743 1.91846 16.5118 1.91846",
    stroke: "#FE706F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8129 10.6514C18.2795 10.6835 18.7434 10.7497 19.2002 10.8525C19.8348 10.9767 20.5982 11.2369 20.8699 11.8063C21.0434 12.171 21.0434 12.5956 20.8699 12.9612C20.5991 13.5306 19.8348 13.7898 19.2002 13.9203",
    stroke: "#FE706F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.48799 7.57672C3.92548 7.57672 2.65796 6.31009 2.65796 4.74759C2.65796 3.18509 3.92548 1.91846 5.48799 1.91846",
    stroke: "#FE706F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.18691 10.6514C3.7203 10.6835 3.25638 10.7497 2.79961 10.8525C2.16495 10.9767 1.40158 11.2369 1.13073 11.8063C0.956423 12.171 0.956423 12.5956 1.13073 12.9612C1.40068 13.5306 2.16495 13.7898 2.79961 13.9203",
    stroke: "#FE706F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9953 11.2603C14.1614 11.2603 16.8663 11.7394 16.8663 13.6567C16.8663 15.5732 14.1793 16.0702 10.9953 16.0702C7.82826 16.0702 5.12427 15.5911 5.12427 13.6737C5.12427 11.7564 7.81127 11.2603 10.9953 11.2603Z",
    stroke: "#FE706F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9953 8.52558C8.90715 8.52558 7.23291 6.85134 7.23291 4.76234C7.23291 2.67424 8.90715 1 10.9953 1C13.0834 1 14.7576 2.67424 14.7576 4.76234C14.7576 6.85134 13.0834 8.52558 10.9953 8.52558Z",
    stroke: "#FE706F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersPrimary);
export default __webpack_public_path__ + "static/media/users-primary.ca64e349762a539049abd299523a2de4.svg";
export { ForwardRef as ReactComponent };